module.exports = __webpack_public_path__ + "media/upcoming.e7f78f83.webm";